import { createSlice } from '@reduxjs/toolkit';

import {sampleMeasurementData , receivedIndiaBoxes, uploadSampleMeasurementsFile, downloadSampleMeasurementFile } from '../../apis';

export const finalMeasurementsPlatform = createSlice({

    name: 'finalMeasurements',
    initialState: {
        loading: false,
        error: '',
        receivedIndiaBoxesData: [],
        sampleMeasurementDataSuccess: false,
        uploadSampleMeasurementsFileSuccess: false,
        downloadSampleMeasurementFileSuccess: false,
    },
    reducers: {
        clear: (state, action) => {
            return {
              ...state,
              [action.payload.key]: action.payload.value
            }
          }
    },
    extraReducers: (builder) => {
        builder.addCase(receivedIndiaBoxes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(receivedIndiaBoxes.fulfilled, (state, action) => {
            state.loading = false;
            state.receivedIndiaBoxesData = action.payload.data
        })
        builder.addCase(receivedIndiaBoxes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
        builder.addCase(sampleMeasurementData.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(sampleMeasurementData.fulfilled, (state, action) => {
            state.loading = false;
            state.sampleMeasurementDataSuccess = true
        })
        builder.addCase(sampleMeasurementData.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(uploadSampleMeasurementsFile.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(uploadSampleMeasurementsFile.fulfilled, (state, action) => {
            state.loading = false;
            state.uploadSampleMeasurementsFileSuccess = true
        })
        builder.addCase(uploadSampleMeasurementsFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(downloadSampleMeasurementFile.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(downloadSampleMeasurementFile.fulfilled, (state, action) => {
            state.loading = false;
            state.downloadSampleMeasurementFileSuccess = true
        })
        builder.addCase(downloadSampleMeasurementFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
    }
})

export const { clear } = finalMeasurementsPlatform.actions

export default finalMeasurementsPlatform.reducer